/**
 * Et medlem uten rom (DD-01 presisert 2026-09-25, konseptets skjerm 7). Kontoen er aktiv —
 * ingen feilfarge — skallet har ingen sider, og meldingen peker på navnet på siden en eier
 * finner deg på, uten adresser (K36). «du»-tiltalen er DD-60s andre navngitte unntak: subjektet
 * er brukerens egen konto. Samme skjerm når rommet ble tatt etter innlogging (403
 * `insufficient_role` henter «meg» på nytt, `api/klient.ts`).
 */
export function UtenRom({ leietaker }: { leietaker: string | undefined }) {
  const hos = leietaker ?? 'leietakeren';
  return (
    <div className="panel-innst panel-uten-rom">
      <h1 className="panel-h1">Ingen arbeidsrom ennå</h1>
      <p className="panel-tekst">
        Kontoen din hos {hos} er aktiv, men den har ikke fått tilgang til noe arbeidsrom. En eier hos {hos} gir det under «Panelbrukere» — spør den som la deg til.
      </p>
      <p className="panel-tekst panel-uten-rom-neste">Når det er gjort, er sidene her neste gang du åpner panelet.</p>
    </div>
  );
}
